import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SxProps,
} from "@mui/material";
import { Team } from "../../types";
import { naturalCompare } from "../../naturalSort";

export interface Props {
  label: string;
  teams: Team[];
  selected?: Team;
  onChange: (team: Team) => void;
  sx?: SxProps;
}

export const TeamSelector = ({
  label,
  teams,
  selected,
  onChange,
  sx,
}: Props) => {
  // Placeholder entries (empty id, e.g. "Select Team") stay pinned at the top;
  // real teams are sorted naturally below them.
  const sortedTeams = [...teams].sort((a, b) => {
    const aPlaceholder = a.id === "";
    const bPlaceholder = b.id === "";
    if (aPlaceholder !== bPlaceholder) return aPlaceholder ? -1 : 1;
    return naturalCompare(a.name, b.name);
  });
  return (
    <FormControl style={{ minWidth: 190, maxWidth: 190 }} size="small" sx={sx}>
      <InputLabel id="team-select-label">{label}</InputLabel>
      <Select
        labelId="team-select-label"
        id="team-select"
        value={selected?.id || []}
        label={label}
        onChange={(e) => {
          const target = teams.find((target) => target.id == e.target.value);
          target && onChange(target);
        }}
      >
        {sortedTeams.map((team, index) => (
          <MenuItem key={index} value={team.id}>
            {team.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
